import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { ClientContextService } from '../services/context/client-context.service';

/**
 * Nebula's own gateway routes (`gateway/nebula/...`) require the caller's client on every
 * request via a `client-id` header — unlike the rest of Coulson's gateway, which takes it as a
 * path segment or body field. Applied globally (like requestLogInterceptor/authHttpInterceptorFn)
 * so every caller gets it automatically regardless of which service issues the request
 * (CoulsonApiService, StoreComparisonApiService, NfDatasourceService, or a Toolbelt-native
 * remote-select field via ToolbeltHttpService) — none of them need to set this header themselves.
 */
export function nebulaClientIdInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  if (!req.url.includes('/gateway/nebula/')) {
    return next(req);
  }

  const clientId = inject(ClientContextService).selectedClientId();
  if (!clientId) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { 'client-id': clientId } }));
}
